import { RefreshCw } from "lucide-react";
import type { AssessmentResult, RoadmapNode } from "../../data/ch_concepts";
import type { TopicSelectPayload } from "./TopicPanel";
import { RoadmapGraph } from "./roadmap-graph/RoadmapGraph";

// Re-export for backward compatibility
export type { TopicSelectPayload } from "./TopicPanel";

// ─── Main ──────────────────────────────────────────────────────────────────────

interface KnowledgeRoadmapProps {
  assessment: AssessmentResult;
  onRetake: () => void;
  isMobile?: boolean;
  isGenerating?: boolean;
  onTopicSelect?: (payload: TopicSelectPayload | null) => void;
}

export function KnowledgeRoadmap({ assessment, onRetake, isMobile = false, isGenerating = false, onTopicSelect }: KnowledgeRoadmapProps) {
  const areas = assessment.areas ?? [];

  function handleTopicClick(node: RoadmapNode, areaLabel: string, areaDescription: string) {
    onTopicSelect?.({ node, areaLabel, areaDescription });
  }

  return (
    <div className="flex flex-col h-full">
      {/* Top bar */}
      <div className="flex-shrink-0 flex items-center gap-1.5 px-3 py-2 border-b border-neutral-border/40 bg-gray-50/60 flex-wrap">
        {assessment.summary && (
          <p className="w-full text-[11px] text-neutral-text/60 leading-relaxed mb-1">{assessment.summary}</p>
        )}
        {!isGenerating && (
          <button
            type="button"
            onClick={onRetake}
            className="ml-auto flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-neutral-border text-xs text-neutral-text/50 hover:text-neutral-text/80 hover:border-neutral-border/80 hover:bg-gray-50 transition-colors"
          >
            <RefreshCw className="w-3 h-3" />
            Новая оценка
          </button>
        )}
      </div>

      {/* Graph */}
      <div className="flex-1 overflow-hidden min-h-0">
        {areas.length === 0 ? (
          <p className="text-xs text-neutral-text/40 text-center py-8">Нет данных для отображения</p>
        ) : (
          <RoadmapGraph
            areas={areas}
            isGenerating={isGenerating}
            isMobile={isMobile}
            onTopicSelect={handleTopicClick}
          />
        )}
      </div>
    </div>
  );
}
